import { useMutation, useQueryClient } from 'react-query';
import api from 'services';
import { ContributeWalletTransferPayload, SuccessResponse } from 'services/requests';
import type { ApiError } from 'services/api.errors';
import { MutationKeys } from 'constants/mutationKeys';
import type { AxiosError } from 'axios';

export const useAssignWalletTransfer = () => {
  const queryClient = useQueryClient();

  const mutate = async (payload: ContributeWalletTransferPayload) => {
    const { data } = await api.assignWalletTransfer(payload);

    return data;
  };

  const mutationKey = MutationKeys.contributeWalletTransfer;

  return useMutation<
    SuccessResponse,
    AxiosError<ApiError>,
    ContributeWalletTransferPayload
  >(mutationKey, mutate, {
    onSuccess: () => queryClient.invalidateQueries('contributionsList'),
  });
};
